import React from "react";

import { ChipsCustom } from "@/components/atoms/ChipsCustom/ChipsCustom";
import { RideSkeleton  } from "@rimac-seguros/ride-system-components";

export const PaymentFrequency = ({ list, frequency, loading, onSelected }) => {
  const selectFrequency = (item) => {
    if (frequency && frequency.value === item) return;
    onSelected(item);
  };

  return (
    <>
      <div className="relative py-ride-gl-spacing-4xlarge">
        <h2 className="flex items-center ride-sys-text-title-xlarge-default mb-ride-gl-spacing-2xlarge gap-ride-gl-spacing-large lg:ride-sys-text-title-2xlarge-default lg:mb-ride-gl-spacing-4xlarge">
          Elige como quieres pagar
        </h2>
        {!loading && list?.length > 0 ? (
          <div className="flex gap-ride-gl-spacing-xlarge lg:gap-ride-gl-spacing-2xlarge">
            {list.map((item) => (
              <ChipsCustom
                key={item.value}
                selected={item.value === frequency}
                onClick={() => selectFrequency(item.value)}
              >
                {item.text}
              </ChipsCustom>
            ))}
          </div>
        ) : (
          <RideSkeleton type="rectangle" height={48} width="100%" />
        )}
      </div>
    </>
  );
};
